export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7533.d9b2f259.jpg";